import React, { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './ReelRoom.module.scss';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import MailRoomInfoBar from '../../components/MailRoomInfoBar/MailRoomInfoBar';
import EmailListItem from '../../components/EmailListItem/EmailListItem';
import { toast } from 'react-toastify';
import EmailDetails from '../../components/EmailDetails/EmailDetails';
import { MailInfo, MailMessage } from '../../types/mail.types';
import { DeleteEmail, NotifyNewUser, NotifyWelcome } from '../../types/socket.types';
import Api from '../../api/api';
import BaseLayout from '../../layout/base/base.layout';
import { DefaultEventsMap } from '@socket.io/component-emitter';

const socketUrl = process.env.NODE_ENV === 'development' ? 'localhost:3080' : '';
const socket: Socket<DefaultEventsMap, DefaultEventsMap> = io(socketUrl);

export default function ReelRoomPage() {
  const { room, username } = useParams<{ room: string, username: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // const x = {
  //   subject: 'Re: test 5',
  //   from: [
  //       {
  //           address: 'RichardRemmelink@gmail.com',
  //           name: 'Richard Remmelink'
  //       }
  //   ],
  //   to: [
  //       {
  //           address: 'import-test@mailreel.com',
  //           name: ''
  //       }
  //   ],
  //   received: 'Tue Jul 25 2023',
  //   message: {
  //       html: '<div dir=\"ltr\">9855456546545</div><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">Op di 25 jul 2023 om 19:41 schreef Richard Remmelink &lt;<a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;:<br></div><blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\">asdfasdfasdfasdfasdf</div><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">Op di 25 jul 2023 om 19:33 schreef Richard Remmelink &lt;<a href=\"mailto:RichardRemmelink@gmail.com\" target=\"_blank\">RichardRemmelink@gmail.com</a>&gt;:<br></div><blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\">hfjhfhgf</div><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">Op di 25 jul 2023 om 19:28 schreef Richard Remmelink &lt;<a href=\"mailto:RichardRemmelink@gmail.com\" target=\"_blank\">RichardRemmelink@gmail.com</a>&gt;:<br></div><blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\">984654</div><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">Op di 25 jul 2023 om 19:05 schreef Richard Remmelink &lt;<a href=\"mailto:RichardRemmelink@gmail.com\" target=\"_blank\">RichardRemmelink@gmail.com</a>&gt;:<br></div><blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\">alsdjf;ljdslf;jdsalfjlkdsajfdsaf</div><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">Op di 25 jul 2023 om 18:28 schreef Richard Remmelink &lt;<a href=\"mailto:RichardRemmelink@gmail.com\" target=\"_blank\">RichardRemmelink@gmail.com</a>&gt;:<br></div><blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\"><br></div><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">Op di 25 jul 2023 om 18:23 schreef Richard Remmelink &lt;<a href=\"mailto:RichardRemmelink@gmail.com\" target=\"_blank\">RichardRemmelink@gmail.com</a>&gt;:<br></div><blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\">asdf</div><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">Op di 25 jul 2023 om 18:10 schreef Richard Remmelink &lt;<a href=\"mailto:RichardRemmelink@gmail.com\" target=\"_blank\">RichardRemmelink@gmail.com</a>&gt;:<br></div><blockquote class=\"gmail_quote\" style=\"margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex\"><div dir=\"ltr\"><br><br><div class=\"gmail_quote\"><div dir=\"ltr\" class=\"gmail_attr\">---------- Forwarded message ---------<br>Van: <strong class=\"gmail_sendername\" dir=\"auto\">Richard Remmelink</strong> <span dir=\"auto\">&lt;<a href=\"mailto:RichardRemmelink@gmail.com\" target=\"_blank\">RichardRemmelink@gmail.com</a>&gt;</span><br>Date: di 25 jul 2023 om 18:08<br>Subject: test 5<br>To:  &lt;<a href=\"mailto:import-test@mailreel.com\" target=\"_blank\">import-test@mailreel.com</a>&gt;<br></div><br><br><div dir=\"ltr\">test 5</div>\n</div></div>\n</blockquote></div>\n</blockquote></div>\n</blockquote></div>\n</blockquote></div>\n</blockquote></div>\n</blockquote></div>\n</blockquote></div>\n',
  //       text: '9855456546545\n\nOp di 25 jul 2023 om 19:41 schreef Richard Remmelink <\nRichardRemmelink@gmail.com>:\n\n> asdfasdfasdfasdfasdf\n>\n> Op di 25 jul 2023 om 19:33 schreef Richard Remmelink <\n> RichardRemmelink@gmail.com>:\n>\n>> hfjhfhgf\n>>\n>> Op di 25 jul 2023 om 19:28 schreef Richard Remmelink <\n>> RichardRemmelink@gmail.com>:\n>>\n>>> 984654\n>>>\n>>> Op di 25 jul 2023 om 19:05 schreef Richard Remmelink <\n>>> RichardRemmelink@gmail.com>:\n>>>\n>>>> alsdjf;ljdslf;jdsalfjlkdsajfdsaf\n>>>>\n>>>> Op di 25 jul 2023 om 18:28 schreef Richard Remmelink <\n>>>> RichardRemmelink@gmail.com>:\n>>>>\n>>>>>\n>>>>>\n>>>>> Op di 25 jul 2023 om 18:23 schreef Richard Remmelink <\n>>>>> RichardRemmelink@gmail.com>:\n>>>>>\n>>>>>> asdf\n>>>>>>\n>>>>>> Op di 25 jul 2023 om 18:10 schreef Richard Remmelink <\n>>>>>> RichardRemmelink@gmail.com>:\n>>>>>>\n>>>>>>>\n>>>>>>>\n>>>>>>> ---------- Forwarded message ---------\n>>>>>>> Van: Richard Remmelink <RichardRemmelink@gmail.com>\n>>>>>>> Date: di 25 jul 2023 om 18:08\n>>>>>>> Subject: test 5\n>>>>>>> To: <import-test@mailreel.com>\n>>>>>>>\n>>>>>>>\n>>>>>>> test 5\n>>>>>>>\n>>>>>>\n',
  //       plain: '<p>9855456546545</p><p>Op di 25 jul 2023 om 19:41 schreef Richard Remmelink &lt;<br/><a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;:</p><p>&gt; asdfasdfasdfasdfasdf<br/>&gt;<br/>&gt; Op di 25 jul 2023 om 19:33 schreef Richard Remmelink &lt;<br/>&gt; <a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;:<br/>&gt;<br/>&gt;&gt; hfjhfhgf<br/>&gt;&gt;<br/>&gt;&gt; Op di 25 jul 2023 om 19:28 schreef Richard Remmelink &lt;<br/>&gt;&gt; <a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;:<br/>&gt;&gt;<br/>&gt;&gt;&gt; 984654<br/>&gt;&gt;&gt;<br/>&gt;&gt;&gt; Op di 25 jul 2023 om 19:05 schreef Richard Remmelink &lt;<br/>&gt;&gt;&gt; <a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;:<br/>&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt; alsdjf;ljdslf;jdsalfjlkdsajfdsaf<br/>&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt; Op di 25 jul 2023 om 18:28 schreef Richard Remmelink &lt;<br/>&gt;&gt;&gt;&gt; <a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;:<br/>&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt; Op di 25 jul 2023 om 18:23 schreef Richard Remmelink &lt;<br/>&gt;&gt;&gt;&gt;&gt; <a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;:<br/>&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt; asdf<br/>&gt;&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt; Op di 25 jul 2023 om 18:10 schreef Richard Remmelink &lt;<br/>&gt;&gt;&gt;&gt;&gt;&gt; <a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;:<br/>&gt;&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt; ---------- Forwarded message ---------<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt; Van: Richard Remmelink &lt;<a href=\"mailto:RichardRemmelink@gmail.com\">RichardRemmelink@gmail.com</a>&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt; Date: di 25 jul 2023 om 18:08<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt; Subject: test 5<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt; To: &lt;<a href=\"mailto:import-test@mailreel.com\">import-test@mailreel.com</a>&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt; test 5<br/>&gt;&gt;&gt;&gt;&gt;&gt;&gt;<br/>&gt;&gt;&gt;&gt;&gt;&gt;</p>'
  //   }} as MailMessage;
  const [emails, setEmails] = useState<MailInfo[]>([]);
  const [selectedEmail, setSelectedEmail] = useState<MailMessage | null>(null);

  if (!room) {
    navigate('/');
  }

  function clear(): void {
    // clear api
    setEmails([]);
    toast(t('AllEmailsRemoved'), { type: 'success' });
  }

  function onDelete(mailId: string): void {
    socket.emit('deleteEmail', { mailId });
    removeEmailFromState(mailId);
    toast(t('EmailRemoved'), { type: 'success' });
  }

  function onDownload(id: string): void {
    fetch(`/api/download/${id}`)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));

        // Create a temporary link element and click it programmatically to trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'filename'); // Set the desired file name here
        document.body.appendChild(link);
        link.click();

        // Clean up the URL object to release memory
        window.URL.revokeObjectURL(url);
      }).catch(() => {
        toast(t('UnableToDownloadFile', { type: 'error' }));
      });
  }

  function openEmail(id: string): void {
    Api.getMail(id).then(mail => {
      setSelectedEmail({ ...mail, id });
    }).catch(() => {
      toast(t('UnableToFetchMail', { type: 'error' }));
    });
  }

  function removeEmailFromState(mailId: string): void {
    setEmails(prev => prev.filter(mail => mail.id !== mailId));
    if (selectedEmail?.id === mailId) {
      setSelectedEmail(null);
    }
  }

  function onLeave(): void {
    socket.emit('userLeave');
    navigate('/');
  }

  useEffect(() => {
    if (socket) {
      socket.emit('join', { room, username });

      socket.on('newMail', (mail: MailInfo) => {
        setEmails(prev => [...prev, mail]);
      });

      socket.on('notifyNewUser', (pack: NotifyNewUser) => {
        toast(pack.message, { type: 'success' });
      });

      socket.on('notifyWelcome', (pack: NotifyWelcome) => {
        toast(pack.message, { type: 'success' });
      });

      socket.on('notifyDeleteEmail', (pack: DeleteEmail) => {
        toast(pack.message, { type: 'success' });
        removeEmailFromState(pack.fileId);
      });
    }
  }, [socket]);

  return (
    <BaseLayout>
      <div className={styles.roomContainer}>
        <MailRoomInfoBar inbox={room} onClear={clear} onLeave={onLeave}/>

        <div className={styles.incomingMails}>
          <Table>
            <thead>
              <tr>
                <th>{t('From')}</th>
                <th>{t('To')}</th>
                <th>{t('Subject')}</th>
                <th>{t('Received')}</th>
              </tr>
            </thead>
            <tbody>
              {emails.map(email => (
                <EmailListItem
                  key={email.id}
                  email={email}
                  openEmail={openEmail}
                  onDelete={onDelete}
                  onDownload={onDownload}
                />
              ))}
            </tbody>
          </Table>
        </div>
        {selectedEmail &&
          <EmailDetails email={selectedEmail} onDelete={onDelete} onDownload={onDownload}/>
        }
      </div>
    </BaseLayout>
  );
}
